import { combineReducers } from '@reduxjs/toolkit';
// slices
import permissionReducer from './slices/permissionSlice';
import roleReducer from './slices/roleSlice';
import userReducer from './slices/userSlice';
// services
import { businessService } from './services/businessService';
import { clientService } from './services/clientService';
import { commonService } from './services/commonService';
import { companyService } from './services/companyService';
import { contractService } from './services/contractService';
import { incomeService } from './services/incomeService';
import { permissionService } from './services/permissionService';
import { quotationService } from './services/quotationService';
import { roleService } from './services/roleService';
import { serviceService } from './services/serviceService';
import { supplierService } from './services/supplierService';
import { userService } from './services/userService';

// ----------------------------------------------------------------------

/**
 * O estado nao e persistido: a sessao vive do refresh token e os dados de
 * negocio sao sempre lidos da API, para nao haver caches locais desactualizados
 * ao trocar de empresa (multi-tenant).
 */
const rootReducer = combineReducers({
  permission: permissionReducer,
  role: roleReducer,
  user: userReducer,
  [businessService.reducerPath]: businessService.reducer,
  [clientService.reducerPath]: clientService.reducer,
  [commonService.reducerPath]: commonService.reducer,
  [companyService.reducerPath]: companyService.reducer,
  [contractService.reducerPath]: contractService.reducer,
  [incomeService.reducerPath]: incomeService.reducer,
  [permissionService.reducerPath]: permissionService.reducer,
  [quotationService.reducerPath]: quotationService.reducer,
  [roleService.reducerPath]: roleService.reducer,
  [serviceService.reducerPath]: serviceService.reducer,
  [supplierService.reducerPath]: supplierService.reducer,
  [userService.reducerPath]: userService.reducer,
});

export default rootReducer;
